import React from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import SVG from 'components/SVG';
import upSVG from 'features/reports/img/up.svg';
import downSVG from 'features/reports/img/down.svg';
import { generalReportMetrics } from 'features/reports/data';
import convertToAmericanFormat from 'shared/helpers/convertToAmericanFormat';

import ActiveUsersLoading from 'features/reports/view/desktop/Pages/FinancialReports/General/ActiveUsersLoading/ActiveUsersLoading';

import './Table.scss';

const b = block('reports-table-general');

const Table = ({ activeMetric, onMetricSelect, withDiff, values, onActiveUsersToggle }) => {
  const locale = useSelector(state => state.locale.locale);
  const { currency } = useSelector(state => state.auth);
  const { detail, diff } = useSelector(state => state.reports.statisticProvider);

  return (
    <section className={b()}>
      <div className={b('heading')}>
        <h2 className={b('title')}>{locale.total}</h2>
        {detail.lastCalculateTime && (
          <span className={b('update-time')}>{`${locale.lastUpdateTime}: ${detail.lastCalculateTime}`}</span>
        )}
      </div>
      <div className={b('table')}>
        {generalReportMetrics.map(item => {
          const isActiveUsers = item.key === 'activeUsers';
          const activeUsersData = values.isActiveUsersEnabled ? values.activeUsers.data : null;
          const metricDiff = isActiveUsers ? activeUsersData?.diff : diff;
          const percent = Number(metricDiff?.[`${item.key}Percent`] || 0);
          const previous = metricDiff?.[item.key];
          const isLoading = isActiveUsers && values.isActiveUsersEnabled && values.activeUsers.isLoading;
          const value = isActiveUsers ? activeUsersData?.detail?.activeUsers : detail?.[item.key] ?? 0;

          return (
            <div key={item.key} className={b('card', { active: activeMetric === item.key })}>
              {isActiveUsers && (
                <button
                  type="button"
                  role="switch"
                  aria-label={locale.activeUsers}
                  aria-checked={values.isActiveUsersEnabled}
                  disabled={values.activeUsers.isLoading}
                  className={b('active-users-switch', { active: values.isActiveUsersEnabled })}
                  onClick={onActiveUsersToggle}>
                  <span />
                </button>
              )}
              <button
                type="button"
                className={b('card-button')}
                onClick={() => onMetricSelect(item.key)}
                disabled={isActiveUsers && (!values.isActiveUsersEnabled || values.activeUsers.isLoading)}
                aria-pressed={activeMetric === item.key}>
                <span className={b('card-title')}>{locale[item.label]}</span>
                <span className={b('card-value')}>
                  {isLoading ? (
                    <ActiveUsersLoading />
                  ) : value == null ? '—' : convertToAmericanFormat(String(value))}
                  {item.suffix || ''}
                  {item.currency && <span className={b('card-currency')}>{currency}</span>}
                </span>
                {withDiff && !isLoading && (!isActiveUsers || previous != null) && (
                  <span className={b('card-diff')}>
                    {percent !== 0 && (
                      <SVG className={b('card-diff-icon')} svgProps={{ svg: percent > 0 ? upSVG : downSVG }} />
                    )}
                    <span className={b('card-diff-percent', { positive: percent > 0, neutral: percent === 0 })}>
                      {`${percent > 0 ? '+' : ''}${percent}%`}
                    </span>
                    <span className={b('card-diff-value')}>
                      {convertToAmericanFormat(String(previous ?? 0))}
                      {item.suffix || ''}
                    </span>
                  </span>
                )}
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Table;
